import { render } from "./shoppable-hotspot.vue?vue&type=template&id=40ee3ef2"
import script from "./shoppable-hotspot.vue?vue&type=script&lang=js"
export * from "./shoppable-hotspot.vue?vue&type=script&lang=js"

import "./shoppable-hotspot.vue?vue&type=style&index=0&id=40ee3ef2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__